export default "__VITE_ASSET__De3fDHsi__"